var $ = require('jquery');
var mq = require('mq');

var is_open = false;

var ttl = new TimelineMax({
    paused : true,
    onComplete: function(){}
});

// ttl.fromTo( $('.header__blocb'), 0.05, {
// 	x: '101%'
// 	// opacity: 0
// }, {
// 	x: '0%',
// 	// opacity: 1,
// 	ease: Power1.easeOut
// });

// // ttl.fromTo( $('.header__blocb__bg'), 1, {
// // 	x: '-101%'
// // 	// opacity: 0
// // }, {
// // 	x: '0%',
// // 	// opacity: 1,
// // 	ease: Power1.easeOut
// // });

// ttl.fromTo( $('.header__blocb__bg'), 1, {
// 	x: '20%',
// 	opacity: 0
// }, {
// 	x: '0%',
// 	opacity: 1,
// 	ease: Power1.easeOut
// });

// ttl.staggerFromTo( $('.header__blocb__toggler, .header__blocb .menu-item, .header__blocb .contact__cta__big'), 1, {
// 	opacity: 0,
// 	x: 50
// }, {
//     opacity: 1,
// 	x: 0,
// 	ease: Power2.easeOut
// }, 0.1, 0.5);




var toggleMenu = function(){
	// alert('b')
	if ( !is_open ) {
		var tl = gsap.timeline({paused : true})
		var start = 0.3;
		var langStagger = 0.07;
		// tl.fromTo( $('.header .header__language__list li'), {
		// 	opacity: 0
		// }, {
		// 	opacity: 1,
		// 	ease: 'none',
		// 	stagger: 0.07
		// }, start)
		// var itemsQuery = '.header__iconic__only__pho, .header .header__menu__ul__a li, .header__langs, .header__tel__wrap, .header__contact, .header__menu__dropdown > .header__menu__dropdown__title, .main__menu__footer, .header__language__list, .header__menu__nav__bot__right';
		var itemsQuery = '.xxx';
		$(itemsQuery).addClass('wc')
		tl.fromTo( $(itemsQuery), {
			opacity: 0,
			y: '30rem'
		}, {
			opacity: 1,
			y: '0rem',
			duration: 0.7,
			ease: 'power2.out',
			stagger: 0.02
		}, start + ( langStagger * 2 ))
		tl.play();
	}
	else {
		
	}
	is_open = !is_open;
	$('body').toggleClass( 'is-main-menu-open' );
	$('.header').removeClass('is-submenu-visible');
	$('.is-sub-menu-open').removeClass('is-sub-menu-open');
	$(window).trigger('menuToggle', [is_open]);
};

var toggleSubMenu = function(evt){
	console.log('toggleSubMenu');
	var el = $(evt.currentTarget);
	var id = $(el).attr('data-js-toggle-submenu');
	console.log('id', id);
	$('[data-js-submenu="'+id+'"]').toggleClass('is-active');
	if ( $('[data-js-submenu="'+id+'"]').hasClass('is-active') ) {
		var tl = gsap.timeline({paused : true})
		var start = 0.3;
		var langStagger = 0.07;
		var $items = $('[data-js-submenu="'+id+'"]').find('.header__menu__dropdown__title, .menu__item__li ')
		$items.addClass('wc')
		tl.fromTo( $items, {
			opacity: 0,
			y: '30rem'
		}, {
			opacity: 1,
			y: '0rem',
			duration: 0.7,
			ease: 'power2.out',
			stagger: 0.02
		}, start + ( langStagger * 2 ))
		tl.play();
	}
};

// alert('a')
$( document ).on('click', '[data-js="toggle-main-menu"]', toggleMenu);
$( document ).on('click', '[data-js-toggle-submenu]', toggleSubMenu);


module.exports = function(){
	if ( is_open ) {
		toggleMenu();
	}
};